import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import MoviesPage from "../../pages/MoviesPage";
import { MovieData } from "../../utils/types/app.types";
import { useSelector, useDispatch } from "react-redux";
import {
  updatePromoMovies,
  updatePopularMovies,
} from "../../store/slices/movies.slice.ts";
import { RootState } from "../../store/store.ts";
import { init } from "../../utils/GlobalFunctions/initialize.ts";

const NowPlayingPage: React.FC = () => {
  const swiperInitRef = useRef<number | null>(null);
  const sessionData = useSelector((state: RootState) => state.session);
  const promoMovies = useSelector(
    (state: RootState) => state.movies.promoMovies,
  );
  const popularMovies = useSelector(
    (state: RootState) => state.movies.popularMovies,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    init(
      dispatch,
      sessionData,
      "movie/now_playing",
      promoMovies,
      updatePromoMovies,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    init(
      dispatch,
      sessionData,
      "movie/popular",
      popularMovies,
      updatePopularMovies,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (promoMovies.length === 0) return;
    swiperInitRef.current = window.setTimeout(() => {
      window.initSwiper?.();
    }, 0);
    return () => {
      if (swiperInitRef.current !== null) {
        window.clearTimeout(swiperInitRef.current);
      }
    };
  }, [promoMovies]);

  return (
    <>
      <section className="now-playing">
        <h2>Now Playing</h2>
        <div className="swiper">
          <div className="swiper-wrapper">
            {promoMovies.length > 0 &&
              promoMovies.map((movie: MovieData) => (
                <div className="swiper-slide" key={movie.id}>
                  <Link to={`/movie-details/${movie.id}`}>
                    <img
                      src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                      alt={`${movie.title}`}
                    />
                  </Link>
                  <h4 className="swiper-rating">
                    <FontAwesomeIcon
                      icon={faStar}
                      style={{ color: "#f1c40f" }}
                    />
                    &nbsp;
                    {movie.vote_average} / 10
                  </h4>
                </div>
              ))}
          </div>
        </div>
      </section>

      <MoviesPage />
    </>
  );
};

export default NowPlayingPage;
